import { ProjectType } from '@/api/rest/resources/types/project';
import { useProjectDetailById } from '@/pages/shared/hooks/useProjectDetailById';
import { WaterDetailPage as WaterDetailConservationPage } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/pages/water/WaterDetail.page';
import { WaterDetailPage } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/water/WaterDetail.page';

export const WaterDetailPages = () => {
  const project = useProjectDetailById().data;

  switch (project?.type) {
    case ProjectType.agriculture:
      return <WaterDetailPage />;
    case ProjectType.conservation:
      return <WaterDetailConservationPage />;
    default:
      return <WaterDetailPage />;
  }
};
